import React from 'react'
import { toTitleCase } from '@mobi/utils/string'
import type { FieldSummary } from '@core/Areas/RaceCardFixedOnly/Types/FieldSummary'
import {
  PropositionJockeyNameStyled,
  PropositionStrongFieldsStyled,
  PropositionSummaryStyled,
  PropositionTrainerNameStyled,
  PropositionTrotFieldStyled,
  SelectionFormTableStyled,
} from '@core/Areas/RaceCardFixedOnly/RaceCardFixedOnly.styles'

type Props = {
  summary: FieldSummary
}
export const TrotFieldSummary: React.FC<Props> = ({ summary }) => {
  if (!summary) return null

  return (
    <PropositionSummaryStyled>
      <SelectionFormTableStyled>
        <PropositionTrotFieldStyled>
          <div>
            <PropositionStrongFieldsStyled>F:</PropositionStrongFieldsStyled>
            <span>{summary.lastFour}</span>
          </div>
          <div>
            <span>{summary.handicapDistance}</span>
          </div>
        </PropositionTrotFieldStyled>
        <PropositionJockeyNameStyled>
          <PropositionStrongFieldsStyled>D:</PropositionStrongFieldsStyled>
          <span className={summary.isRiderChanged ? 'rider-change fg-gray-lightest' : ''}>
            {summary.jockeyName ? toTitleCase(summary.jockeyName) : summary.jockeyName}
          </span>
        </PropositionJockeyNameStyled>
        <PropositionTrainerNameStyled>
          <PropositionStrongFieldsStyled>T:</PropositionStrongFieldsStyled>
          <span>
            {summary.trainerName ? toTitleCase(summary.trainerName) : summary.trainerName}
          </span>
        </PropositionTrainerNameStyled>
      </SelectionFormTableStyled>
    </PropositionSummaryStyled>
  )
}
